<template>
<div>
  <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-hero section-shaped my-0">
          <div class="shape shape-style-1 bg-gradient-default shape-primary">
              <span class="span-150"></span>
              <span class="span-50"></span>
              <span class="span-50"></span>
              <span class="span-75"></span>
              <span class="span-100"></span>
              <span class="span-75"></span>
              <span class="span-50"></span>
              <span class="span-100"></span>
              <span class="span-50"></span>
              <span class="span-100"></span>
          </div>
          <div class="container shape-container d-flex align-items-center">
              <div class="col px-0">
                  <div class="row justify-content-center align-items-center">
                      <div class="col-lg-12 text-center">
                          <h1 class="text-white">Aprenda do Zero Tudo Sobre Bitcoin</h1>
                          <p class="lead text-light mt-4 mb-5 col-lg-7 mx-lg-auto">Aprenda tudo sobre investimento em Bitcoins e comece a negociar essa e outras criptomoedas relevantes para o mercado!</p>
                          <div class="btn-wrapper" id="saiba-mais">
                              <base-button tag="a"
                                           href="#saiba-mais"
                                           class="mb-3 mb-sm-0"
                                           type="warning"
                                           size="lg"
                                           style="font-size:20px;width:260px;">
                                  Saiba mais
                              </base-button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <!-- 1st Hero Variation -->
      <section class="section section-shaped my-0 overflow-hidden">
          <div class="shape shape-style-3 bg-gradient-default shape-skew">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
          </div>
          <div class="container pb-200">
              <div class="row text-center justify-content-center">
                  <div class="col-lg-6 mb-5">
                    <h2 class="display-3 text-warning">Confira o preço atual da Bitcoin</h2>
                    <div class="coinmarketcap-currency-widget my-lg-5 lead" data-currencyid="1" data-base="BRL" data-secondary="" data-ticker="false" data-rank="false" data-marketcap="false" data-volume="false" data-stats="USD" data-statsticker="false"></div>
                  </div>
                  <div class="col-lg-6">
                      <h2 class="display-3 text-warning">Por que aprender sobre Bitcoins?</h2>
                      <p class="lead text-white">
                        Nesse momento, milhares de pessoas estão se aproximando do sonho da renda passiva através do investimento em Bitcoins.
                        <br /><br />
                        Comece a se preparar para comprar e vender as criptomoedas mais rentáveis do mercado!
                      </p>
                  </div>
              </div>
              <!-- <div class="row row-grid mt-5">
                  <div class="col-lg-12">
                    <div class="embed-responsive embed-responsive-16by9">
                      <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/CvQlxHXmHrc?rel=0&controls=0&showinfo=0" allowfullscreen></iframe>
                    </div>
                  </div>
              </div> -->
              <div class="row row-grid text-center mt-5">
                  <div class="col-lg-12 btn-wrapper">
                      <base-button tag="a"
                                   href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487"
                                   class="mb-3 mb-sm-0"
                                   type="warning"
                                   size="lg"
                                   style="font-size:20px;">
                          Quero fazer o curso
                      </base-button>
                  </div>
              </div>
          </div>
      </section>

      <section class="section section section-shaped my-0 overflow-hidden">
          <div class="container py-0">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-dark">Qualquer pessoa é capaz de investir em Bitcoins!</h2>
                </div>
            </div>
            <div class="row row-grid mt-5 text-center">
                <div class="col-lg-6">
                    <icon name="ni ni-money-coins" size="lg" gradient="white" shadow color="primary"></icon>
                    <h5 class="text-dark mt-3">COMPRA E VENDA DE BITCOINS</h5>
                    <p class="text-dark mt-3">Aprenda a comprar e vender Bitcoins no Brasil e no exterior.</p>
                </div>
                <div class="col-lg-6">
                    <icon name="ni ni-paper-diploma" size="lg" gradient="white" shadow color="primary"></icon>
                    <h5 class="text-dark mt-3">ENTENDA TUDO SOBRE BLOCKCHAIN</h5>
                    <p class="text-dark mt-3">Saiba como funciona a tecnologia que está revolucionando o mundo financeiro.</p>
                </div>
                <div class="col-lg-6">
                    <icon name="ni ni-hat-3" size="lg" gradient="white" shadow color="primary"></icon>
                    <h5 class="text-dark mt-3">TORNE-SE ESPECIALISTA</h5>
                    <p class="text-dark mt-3">Domine todos os termos do mercado e saiba exatamente quando comprar e vender todos os tipos de criptomoedas.</p>
                </div>
                <div class="col-lg-6">
                    <icon name="ni ni-satisfied" size="lg" gradient="white" shadow color="primary"></icon>
                    <h5 class="text-dark mt-3">CRESÇA SEU INVESTIMENTO</h5>
                    <p class="text-dark mt-3">Aprenda sobre outras criptomoedas como Ethereum e Dash e saiba decidir sobre os seus próximos investimentos.</p>
                </div>
            </div>
            <div class="row row-grid text-center mt-5">
                <div class="col-lg-12 btn-wrapper">
                    <base-button tag="a"
                                 href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487"
                                 class="mb-3 mb-sm-0"
                                 type="warning"
                                 size="lg"
                                 style="font-size:20px;white-space:unset;">
                        Aprenda a investir agora
                    </base-button>
                </div>
            </div>
          </div>
      </section>
      <section class="section section-lg">
          <div class="container">
              <div class="row justify-content-center text-center mb-lg">
                  <div class="col-lg-8">
                      <h2 class="display-3 text-dark">O que você vai aprender</h2>
                  </div>
              </div>

                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-left">
                            <div class="col-lg-8">
                                <h3 class="text-white">MÓDULO 1 - Conceitos introdutórios</h3>
                                <p class="lead text-light mt-3">

                                      Definição de Bitcoin e como ela foi criada
                                    <br />
                                      O que é e como funciona uma Blockchain
                                    <br />
                                      Como é feita a mineração de Bitcon
                                    <br />
                                      Porque a Bitcoin é segura
                                    <br />
                                      Como cuidar da sua segurança pessoal

                                </p>
                            </div>
                            <div class="col-lg-4 pt-4 d-none d-md-block" style="height: 230px;">
                              <img :src="require('@/assets/img/woman_sitting_pc.svg')" style="margin-left: 20px;" />
                            </div>
                        </div>
                    </div>
                </card>
                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0 mt-5">
                    <div class="p-5">
                        <div class="row align-items-right">
                          <div class="col-lg-4 d-none d-md-block">
                            <img :src="require('@/assets/img/man_holding_wallet.svg')" style="margin-left: 70px;" />
                          </div>
                            <div class="col-lg-8">
                                <h3 class="text-white">MÓDULO 2 - Carteiras de Bitcoins</h3>
                                <p class="lead text-light">

                                      Como é formada uma carteira de Bitcoins
                                    <br />
                                      Entendendo o conceito das chaves pública e privada
                                    <br />
                                      Como é o uso da carteira de Bitcoins da Coinbase
                                    <br />
                                      Como criar e utilizar uma carteira usando Electrum

                                </p>
                            </div>
                        </div>
                    </div>
                </card>
                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0 mt-5">
                    <div class="p-5">
                        <div class="row align-items-left">
                            <div class="col-lg-8">
                                <h3 class="text-white">MÓDULO 3 - Negociando criptomoedas</h3>
                                <p class="lead text-light mt-3">

                                      O que são as exchanges e quais as modalidades de negociação
                                    <br />
                                      Passo a passo de uso das exchanges nacionais Mercado Bitcoin e Walltime
                                    <br />
                                      Passo a passo da exchange internacional Cex.io

                                </p>
                            </div>
                            <div class="col-lg-4 d-none d-md-block">
                              <img :src="require('@/assets/img/computer.svg')" style="margin-left: 50px;"/>
                            </div>
                        </div>
                    </div>
                </card>
                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0 mt-5">
                    <div class="p-5">
                        <div class="row align-items-right">
                          <div class="col-lg-4 d-none d-md-block">
                            <img :src="require('@/assets/img/piggybank.svg')" style="margin: 100px 0 0 70px" />
                          </div>
                            <div class="col-lg-8">
                                <h3 class="text-white">MÓDULO 4 - Entendendo o mercado e outras criptomoedas</h3>
                                <p class="lead text-light">

                                      O que é o Hodl e Trade
                                    <br />
                                      Entendendo a influência da economia mundial
                                    <br />
                                      Como acompanhar o mercado e tomar cuidado com golpes e fraudes
                                    <br />
                                      Aprenda a calcular o retorno do seu investimento
                                    <br />
                                      Definição	de Fork e dos diferentes tipos de Bitcoin
                                    <br />
                                      Entendendo a Ethereum, Tokens e ICOs
                                    <br />
                                      Como analisar se uma nova criptomoeda é promissora

                                </p>
                            </div>

                        </div>
                    </div>
                </card>
                <card gradient="default"
                      no-body
                      shadow-size="lg"
                      class="border-0 mt-5">
                    <div class="p-5">
                        <div class="row align-items-left">
                            <div class="col-lg-8">
                                <h3 class="text-white">MÓDULO 5 - Aspectos jurídicos e conclusões finais</h3>
                                <p class="lead text-light mt-3">

                                      Como funciona a declaração no imposto de renda
                                    <br />
                                      Dicas finais para você investir com segurança

                                </p>
                            </div>
                            <div class="col-lg-4 pt-4 d-none d-md-block">
                              <img :src="require('@/assets/img/man_holding_map.svg')" style="margin-left:60px;" />
                            </div>
                        </div>
                    </div>
                </card>
                <div class="row row-grid text-center mt-5">
                    <div class="col-lg-12 btn-wrapper">
                        <base-button tag="a"
                                     href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487"
                                     class="mb-3 mb-sm-0"
                                     type="warning"
                                     size="lg"
                                     style="font-size:20px;">
                            Quero fazer o curso
                        </base-button>
                    </div>
                </div>
          </div>
      </section>
      <section class="section bg-secondary">
          <div class="container">
              <div class="row row-grid align-items-left">
                  <div class="col-md-6">
                    <div class="pl-md-5">
                        <h3>Eu preciso entender alguma coisa sobre Bitcoin para fazer o curso?</h3>
                        <p class="lead">Não! O curso Aprenda do Zero tudo sobre Bitcoin é voltado para investidores iniciantes que ainda não tiveram contato com Bitcoins e Criptomoedas. Todo o conhecimento necessário para que você comece a investir no seu patrimônio de Bitcoins será apresentado nos cinco módulos do curso.</p>
                        <p class="lead">
                        Você vai aprender TUDO sobre Bitcoins, desde os conceitos básicos até a hora certa de fazer transações nacional e internacionalmente.</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                      <div class="pl-md-5">
                          <h3>Qual é o investimento mínimo para começar a operar com Bitcoins?</h3>
                          <p class="lead">Não existe investimento mínimo. Você pode começar com o valor que puder.
                          Para iniciar o seu investimento, não é nem necessário comprar uma Bitcoin inteira de uma vez: você pode começar comprando uma fração da moeda a partir de R$50,00.</p>
                          <p class="lead">O importante é você entender as formas mais seguras e eficazes de investir e não perder dinheiro!</p>
                      </div>
                  </div>
              </div>
              <div class="row row-grid text-center mt-5">
                  <div class="col-lg-12 btn-wrapper">
                      <base-button tag="a"
                                   href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487"
                                   class="mb-3 mb-sm-0"
                                   type="warning"
                                   size="lg"
                                   style="font-size:20px;white-space:unset;">
                          Comece a aprender para investir com segurança
                      </base-button>
                  </div>
              </div>
          </div>
      </section>
      <section class="section section section-shaped my-0 overflow-hidden">
          <div class="container py-0">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-dark">Qual é o valor do investimento para fazer parte do Aprenda do Zero Tudo Sobre Bitcoin?</h2>
                    <p class="lead text-dark">
                      Por 12x de R$ 48,62*<br />
                      Ou R$ 499,00 à vista
                    </p>
                    <p>
                      O acesso é imediato e <strong>vitalício</strong>!
                    </p>
                </div>
            </div>
            <div class="row row-grid text-center mt-5">
                <div class="col-lg-12 btn-wrapper">
                    <base-button tag="a"
                                 href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487"
                                 class="mb-3 mb-sm-0"
                                 type="warning"
                                 size="lg"
                                 style="font-size:20px;">
                        Se matricule agora
                    </base-button>
                </div>
                <div class="col-lg-12 mt-3">
                  <img :src="require('@/assets/img/logo_mastercard.png')" />
                  <img :src="require('@/assets/img/logo_paypal.png')" />
                  <img :src="require('@/assets/img/logo_boleto.png')" />
                  <img :src="require('@/assets/img/logo_hipercard.png')" />
                  <img :src="require('@/assets/img/logo_visa.png')" />
                  <img :src="require('@/assets/img/logo_hotmart.png')" />
                </div>
                <div class="col-lg-12 mt-3">
                  <small>
                    *Parcelamento com taxa de 2,49% a.m. Imagens meramenta ilustrativas. Compra segura e privacidade protegida. O curso será entregue via vídeo-aula em um portal de membros. Necessária conexão com a internet.
                  </small>
                </div>
            </div>
          </div>
      </section>
      <section class="section section section-shaped my-0 overflow-hidden">
          <div class="container py-0">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-dark">Garantia de devolução</h2>
                </div>
            </div>
            <div class="row row-grid text-center mt-5">
              <div class="col-lg-4">
                <p class="lead">
                  Esse curso possui apenas um pré-requisito: querer aprender a investir em Bitcoins. Mas, se em até 15 dias após a compra você não estiver satisfeito, por qualquer motivo, devolvemos todo o seu investimento!
                </p>
              </div>
              <div class="col-lg-4">
                <img :src="require('@/assets/img/money_back.png')" />
              </div>
              <div class="col-lg-4">
                <p class="lead">
                  Basta solicitar o reembolso por email e a devolução do valor pago será feita com rapidez e sem qualquer ressentimento.<br />
                  Sua satisfação é muito importante para nós!
                </p>
              </div>
            </div>
            <div class="row row-grid text-center mt-5">
              <div class="col-lg-12">
                <h3 class="heading-title">Dúvidas?</h3>
              </div>
            </div>
            <div class="row row-grid text-center mt-5">
              <div class="col-lg-12">
                <p>
                  Entre em contato com a nossa equipe pelo e-mail <a href="mailto:ensinandobitcoin@gmail.com" target="_blank">ensinandobitcoin@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
      </section>
      <section class="section bg-secondary section section-shaped my-0 overflow-hidden">
          <div class="container py-0">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-dark">Perguntas frequentes</h2>
                </div>
            </div>
            <div class="row row-grid text-center justify-content-center mt-5">
                <div class="col-lg-6 mt-0 btn-wrapper" v-for="(q, index) in faq" v-bind:key="index">
                  <button type="button" class="btn btn-block btn-outline-primary mb-3" style="white-space:unset" @click="q.open=true">{{q.question}}</button>

                  <modal :show="q.open" @close="q.open=false" class="modal fade" id="modal-default" tabindex="-1" role="dialog" aria-labelledby="modal-default" aria-hidden="true">
                      <div slot="header">
                          <h6 class="modal-title" id="modal-title-default">{{q.question}}</h6>
                      </div>
                      <p class="text-left">{{q.answer}}</p>
                      <div slot="footer">
                          <button type="button" class="btn btn-primary" @click="q.open=false">Ok, entendi</button>
                      </div>
                  </modal>
                </div>
            </div>
          </div>
      </section>
      <section class="section bg-gradient-default section-shaped my-0 overflow-hidden">
          <div class="container py-0">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-warning">Qual é o valor do investimento para fazer parte do Aprenda do Zero Tudo Sobre Bitcoin?</h2>
                    <p class="lead text-white">
                      Por 12x de R$ 48,62*<br />
                      Ou R$ 499,00 à vista
                    </p>
                    <p>
                      O acesso é imediato e <strong>vitalício</strong>!
                    </p>
                </div>
            </div>
            <div class="row row-grid text-center mt-5">
                <div class="col-lg-12 btn-wrapper">
                    <base-button tag="a"
                                 href="https://pay.hotmart.com/D6506296N?off=ou14kb7u&checkoutMode=10&bid=1574971557487"
                                 class="mb-3 mb-sm-0"
                                 type="warning"
                                 size="lg"
                                 style="font-size:20px;">
                        Se matricule agora
                    </base-button>
                </div>
                <div class="col-lg-12 mt-3">
                  <img class="inverted-image" :src="require('@/assets/img/logo_mastercard.png')" />
                  <img class="inverted-image" :src="require('@/assets/img/logo_paypal.png')" />
                  <img class="inverted-image" :src="require('@/assets/img/logo_boleto.png')" />
                  <img class="inverted-image" :src="require('@/assets/img/logo_hipercard.png')" />
                  <img class="inverted-image" :src="require('@/assets/img/logo_visa.png')" />
                  <img class="inverted-image" :src="require('@/assets/img/logo_hotmart.png')" />
                </div>
                <div class="col-lg-12 mt-3">
                  <small>
                    *Parcelamento com taxa de 2,49% a.m. Imagens meramenta ilustrativas. Compra segura e privacidade protegida. O curso será entregue via vídeo-aula em um portal de membros. Necessária conexão com a internet.
                  </small>
                </div>
            </div>
          </div>
      </section>
      <section class="section section section-shaped my-0 overflow-hidden">
          <div class="container py-0">
            <div class="row text-center justify-content-center">
                <div class="col-lg-10">
                    <h2 class="display-3 text-dark">Quem somos</h2>
                </div>
            </div>
            <div class="row row-grid text-center mt-5">
              <div class="col-md-6 mb-5 mb-lg-0">
                <div class="px-4">
                  <img class="rounded-circle img-center img-fluid shadow" style="width: 200px;" :src="require('@/assets/img/wilson.jpg')">
                  <div class="pt-4 text-center">
                    <h5 class="title">
                      <span class="d-block mb-1">Wilson Tayar</span>
                      <small class="h6 text-muted">Bacharel em sistemas de informação e CTO de uma grande empresa de educação, trabalha na área há mais de 10 anos. Palestrante de criptomoedas há 7 anos e entusiasta de tecnologias como blockchain, criptografia, sistemas distribuídos e algoritmos de consenso. Também é colaborador da Eletronic Frontier Foundation e do World Community Grid.</small>
                    </h5>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-5 mb-lg-0">
                <div class="px-4">
                  <img class="rounded-circle img-center img-fluid shadow" style="width: 200px;" :src="require('@/assets/img/renan.jpg')">
                  <div class="pt-4 text-center">
                    <h5 class="title">
                      <span class="d-block mb-1">Renan Saglia</span>
                      <small class="h6 text-muted">Graduado em Administração de Empresas com Especialização em Controladoria.
Atua na área financeira há mais de 6 anos e se dedicou a solidificar seu conhecimentos em investimentos e planejamento financeiro durante esse tempo.
É entusiasta de Bitcoins e outras criptomoedas e se preocupa em difundir o conhecimento para que mais pessoas tenham acesso a esse mercado.</small>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </section>
  </div>
</div>
</template>

<script>
import Modal from '../components/Argon/Modal.vue';

export default {
  name: 'Landing',
  components: {
    Modal
  },
  data(){
    return {
      openModal: false,
      faq: [{
        question: "Esse curso é online ou presencial?",
        answer: "O curso é on-line. Assim você terá acesso às aulas quando e onde quiser.",
        open: false
      }, {
        question: "Existe prazo para concluir o curso?",
        answer: "Não. Uma vez adquiridas, as aulas estarão sempre disponíveis para você. O curso possui acesso vitalício.",
        open: false
      }, {
        question: "Como funciona o acesso vitalício?",
        answer: "A partir da compra, o curso é seu para sempre. Você pode entrar e assistir as aulas quando quiser e seu acesso não vai expirar com o tempo.",
        open: false
      }, {
        question: "Como vou acessar o curso?",
        answer: "Após processarmos a sua compra, vamos te enviar um email com os dados e link de acesso. O curso está dentro da plataforma da Hotmart e você poderá acessá-lo com seu login e senha.",
        open: false
      }, {
        question: "Esse curso vai mudar?",
        answer: "O mercado e o cenário internacional mudam o tempo todo. Por isso o conteúdo do curso pode mudar de tempos em tempos, para manter os alunos sempre atualizados.",
        open: false
      }, {
        question: "Em caso de dúvidas, terei auxílio?",
        answer: "Sim. Vocë pode contar com nosso suporte por e-mail sempre que precisar.",
        open: false
      }]
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  font-size: 3.3rem;
}

@media (min-width: 576px) {
  h1 {
    font-size: 3.3rem;
  }
}

@media (min-width: 768px) {
  h1 {
    font-size: 3.3rem;
  }
}

@media (min-width: 1200px) {
  h1 {
    font-size: 4.5rem;
  }
}

.inverted-image {
  filter: invert(1);
  mix-blend-mode: screen;
}
</style>
